// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__37SOd","inputWrap":"Table_inputWrap__1s5VI","col":"Table_col__1U3qA","bmiTooltip":"Table_bmiTooltip__3pyRy"};